/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CampsiteTypeFilters from './CampsiteType';
import MustHaveFilters from './MustHaveFilters';
import { updateSearchCriteria } from '../../../actions/search';
import { CampingFiltersProps, FiltersTypeProps } from '../../../types/filters';
import { toggleFilterGroups } from '../../../utils/filters';

function CampingFilters({
    aggregations,
    onApplyFilters,
    onFilterChange,
    onFilterRemove,
    storePath = 'search',
    onCriteriaUpdate,
    hasDates,
}: CampingFiltersProps) {
    const dispatch = useDispatch();
    const search = useSelector((state: Record<string, any>) => state[storePath]);

    const onChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        item: FiltersTypeProps
    ) => {
        event.preventDefault();
        const params = toggleFilterGroups(item, search);
        if (onCriteriaUpdate) {
            onCriteriaUpdate('fg', params);
        } else {
            // @ts-ignore
            dispatch(updateSearchCriteria('fg', params));
        }
        if (onApplyFilters) {
            onApplyFilters();
        }
    };
    return (
        <>
            <CampsiteTypeFilters
                aggregations={aggregations?.camping}
                search={search}
                onApplyFilters={onApplyFilters}
                onFilterChange={onFilterChange}
                onFilterRemove={onFilterRemove}
                onChange={onChange}
                onCriteriaUpdate={onCriteriaUpdate}
            />
            <MustHaveFilters
                onApplyFilters={onApplyFilters}
                aggregations={aggregations?.camping}
                search={search}
                onChange={onChange}
                onCriteriaUpdate={onCriteriaUpdate}
                hasDates={hasDates}
            />
        </>
    );
}

export default CampingFilters;
